export const PRODUCT = 'ATLAS VISUEL DE RADIOLOGIE PRO™'

export const PRODUCT_TAGLINE = 'ANATOMIE, IMAGERIE MÉDICALE, INTERPRÉTATION ET PROTOCOLES CLINIQUES'

/** Anchor id of the €27 purchase section */
export const OFFER_ANCHOR = '#offer'

export const CHECKOUT_URL = 'https://atlas-visuel-radiologie.impultienda.ar/checkout'

const RES =
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/0d5d837a-1fd2-4812-b1ae-3766dabcf357/'

/** Box-set mockup (hero, €27 offer and final CTA). */
export const MOCKUP_IMAGE = RES + '1793830725216_mockup-1080-b25c6b30.png'

export const RESOURCES_BASE = RES

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'

export const PRICE = '27 €'
export const COMPARE_PRICE = '97 €'

/** Meta Pixel ID — pixel 1 (cuenta Argentina, portafolio Ebook Mundial). */
export const PIXEL_ID = '30033654856234824'
